import React from 'react';
import PropTypes from 'prop-types';

import { StyledButton } from './CollectionPaginationButtonStyles';

var CollectionPaginationButton = function CollectionPaginationButton(props) {
  var isNumber = typeof props.pageIndex === 'number';
  return React.createElement(
    StyledButton,
    {
      key: props.pageIndex,
      active: props.pageIndex === props.currentPageIndex,
      'aria-disabled': !isNumber || props.pageIndex === props.currentPageIndex,
      disabled: !isNumber || props.pageIndex === props.currentPageIndex,
      onClick: isNumber ? function () {
        return props.handlePaginationClick(props.pageIndex, true);
      } : null
    },
    isNumber ? props.pageIndex + 1 : props.pageIndex
  );
};

CollectionPaginationButton.propTypes = {
  handlePaginationClick: PropTypes.func.isRequired,
  pageIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  currentPageIndex: PropTypes.number
};

export default CollectionPaginationButton;